import React from "react";
import { Dialog } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import CancelIcon from '@material-ui/icons/Cancel';

const AppPopup: React.FC<{
    title: string,
    open: boolean,
    children: any,
    styles?: React.CSSProperties,
    onClose: (type: boolean) => any,
    maxWidth?: 'lg' | 'md' | 'sm' | 'xl' | 'xs'
    fullScreen?: boolean;
    fullWidth?: boolean;
    scroll?: 'body' | 'paper'
}> = (props) => {
    return (
        <Dialog
            fullScreen={props.fullScreen}
            open={props.open}
            onEscapeKeyDown={() => props.onClose(false)}
            onBackdropClick={() => props.onClose(false)}
            scroll={props.scroll}
            fullWidth={props.fullWidth}
            onClose={() => props.onClose(false)}
            maxWidth={props.maxWidth}
        >
            <DialogTitle className="appPopUpHeader">
                {props.title}
                <span className="appPopupCloseIcon isPrintViewHidden" onClick={() => props.onClose(false)}>
                    <CancelIcon fontSize="large" />
                </span>
            </DialogTitle>
            {props.children}
        </Dialog>
    )
}

export default AppPopup;
